import { ReactElement, useCallback } from 'react';
import { InputValue, normalize } from '@optimus-web/common';
import { LabeledDropdownItem } from '../../DropdownItem';

export const defaultSearchValueMapper = (c: React.ReactElement<LabeledDropdownItem>) => {
    const normalizedLabel = typeof c.props.label === 'string' ? normalize(c.props.label) : '';
    const normalizedDescription = typeof c.props.description === 'string' ? normalize(c.props.description) : '';
    return `${normalizedLabel} ${normalizedDescription}`.trim();
};

export const useValueMapper = (callback?: (c: ReactElement) => InputValue) =>
    useCallback((c: ReactElement) => (callback ? callback(c) : c.props.value), [callback]);
